import { getJsonAsync, putJsonAsync } from './fetchConfig';

export const getAllInterests = () => getJsonAsync('/interests/interest-codes');

export const getHighRiskInterestGroups = () => getJsonAsync('/constants/high-risk-interest-groups');
export const updateHighRiskInterestGroups = (values) => putJsonAsync('/constants/high-risk-interest-groups', values);

export const getHighRiskInterestCodes = () => getJsonAsync('/constants/high-risk-interest-codes');
export const updateHighRiskInterestCodes = (values) => putJsonAsync('/constants/high-risk-interest-codes', values);
